<template>
    <div class="webcastsRisk"></div>
</template>

<script>
export default {
    name: 'webcastsRisk',
    props:{
        pondsid:Number,
        companyId: Number,
        greenhouseId: Number
    },
    data() {
        return {
            myChart: null,
            xData:[],
            fullDateData: [], // 保存完整的日期时间，用于tooltip显示
            yData:[],
            yAxisMin: null, 
            timerSetChart: null, // 用于存储setChart的定时器
            timerGetData: null, // 用于存储getData的定时器// 用于存储动态的y轴最小值
        }
    },
    methods: {
        updateWithDateRange(start, end) {
            // 使用新的 /sensors/history-by-time 接口，支持精确时间
            const params = {
                greenhouseId: this.greenhouseId,
                startDate: start,
                endDate: end,
                pageNum: 1,
                pageSize: 1000
            };
            this.request.get("/api/sensors/history-by-time", {
                params: params
            }).then(res => {
                // 处理返回结果，支持 Result 包装格式
                const list = Array.isArray(res) ? res :
                             (res && Array.isArray(res.data)) ? res.data :
                             (res && Array.isArray(res.records)) ? res.records : [];
                // 按时间正序排序（最旧的在前，最新的在右）
                const sortedList = [...list].sort((a, b) => {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
                // 保存完整日期时间用于tooltip
                this.fullDateData = sortedList.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = sortedList.map(item => {
                    const dateTime = item.createdAt ? item.createdAt.split('T') : [];
                    const timePart = dateTime[1] || '';
                    return timePart.substring(0, 5); // 只显示时:分
                });
                this.yData = sortedList.map(item => item.light || 0);
                this.updateDynamicYAxis();
                this.setWebcasts()
            }).catch(err => {
                console.error('获取历史数据失败:', err);
            });
        },
        setData(){
            this.request.get("/api/sensors/latest",{
                params: {
                    companyId: this.companyId,
                    greenhouseId: this.greenhouseId
                }
            }).then(res => {
                const list = Array.isArray(res) ? res :
                              (res && Array.isArray(res.data) ? res.data :
                              (res && Array.isArray(res.records) ? res.records : []));
                // 按时间正序排序（最旧的在前，最新的在右）
                const sortedList = [...list].sort((a, b) => {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
                // 保存完整日期时间用于tooltip
                this.fullDateData = sortedList.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = sortedList.map(item => {
                    const dateTime = item.createdAt.split('T');
                    const timePart = dateTime[1] || '';
                    return timePart.substring(0, 5); // 只显示时:分
                    });
                this.yData = sortedList.map(item => item.light || 0);
                    this.updateDynamicYAxis();
                    this.setWebcasts()
                })
        },
        updateDynamicYAxis() {
            if (this.yData.length > 0) {
                const minVal = Math.min(...this.yData);
                this.yAxisMin = Math.floor(minVal - 7);
                 // 减去0.1以确保所有数据都能清晰显示
            }
        },
        setWebcasts() {
            const self = this; // 保存this引用
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    formatter: function(params) {
                        let result = '';
                        if (params && params.length > 0) {
                            const index = params[0].dataIndex;
                            const fullDate = self.fullDateData[index];
                            // 格式化完整日期时间
                            if (fullDate) {
                                const dateTime = fullDate.replace('T', ' ');
                                result = dateTime + '<br/>';
                            }
                            params.forEach(param => {
                                result += `${param.seriesName}: ${param.value} lux<br/>`;
                            });
                        }
                        return result;
                    }
                },
                grid: {
                    top: '12%',
                    bottom: '12%',
                    left: '8%',
                    right: '5%',
                },
                legend: {
                    right: '5%',
                    top: '10%',
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 5],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {
                        color: '#122C49',
                        inside: true
                    },
                    z: 2,
                    data: this.xData,
                },
                yAxis:
                    {
                        type: 'value',
                        min: this.yAxisMin,
                        // splitNumber: 8,
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 10,
                            formatter: function(value) {
                return value.toFixed(2); // 保留两位小数
            }
                        },
                        splitLine: {
                            show: false,
                        },
                        name: 'lux',
                        nameGap: -10,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                    },

                series: [{
            name: '光照强度(lux)',
                    type: 'line',
                    symbol: 'none',
                    data: this.yData,
                    animation: true, // 启用动画
            animationDuration: 5000, // 设置动画持续时间为2000毫秒
            animationDelay: function (idx) {
                return idx * 300; // 每个条目设置不同的动画延迟
            },
                    lineStyle: {
                        width: 1,
                        color:{
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#30cfd0' // 0% 处的颜色
                            },
                            {
                                offset: 1, color: '#330867' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        } //背景渐变色
                    },
                    itemStyle: {
                        color: '#330867'
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#E0C3FC' // 0% 处的颜色
                            },
                            {
                                offset: 1, color: '#8EC5FC' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }, //背景渐变色
                        origin: 'start'
                    }
                },
                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
        },
    },
    mounted() {
        // 移除 mounted 中的 setData，只依赖 watch 触发
        // 启动定时器，每2分钟刷新图表，每5分钟获取新数据
        this.timerSetChart = setInterval(() => {
            this.setWebcasts();
        }, 2 * 60 * 1000); // 2分钟

        // 每五分钟执行一次setData
        this.timerGetData = setInterval(() => {
            // 只有当有有效数据时才刷新
            if (this.greenhouseId) {
                this.setData();
            }
        }, 5 * 60 * 1000); // 5分钟
    },
    watch: {
        greenhouseId() {
            this.setData();
        },
        companyId() {
            this.setData();
        },
        pondsid() {
            this.setData();
        }
    },
    beforeDestroy() {
        // 清除定时器
        clearInterval(this.timerSetChart);
        clearInterval(this.timerGetData);
    }
}
</script>

<style lang="less" scoped>
.webcastsRisk {
    margin-top: 5%;
    height: 45%;
}
</style>
